import { add, format, isWeekend } from 'date-fns';
import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { nonTradingDaysAtom, NonTradingDaysOfMarket } from '../../state';

export type GetNonTradingDaysByMic = (mic: string) => NonTradingDaysOfMarket;

export const useNonTradingDaysCommon = () => {
  const [nonTradingDays] = useAtom(nonTradingDaysAtom);

  const getNonTradingDaysByMic: GetNonTradingDaysByMic = useCallback(
    (mic: string) => {
      return nonTradingDays[mic] ?? [];
    },
    [nonTradingDays],
  );

  const getNextTradingDay = useCallback(
    (mic: string): Date => {
      const nonTradingDaysForMic = getNonTradingDaysByMic(mic);

      // initialize nextDay to tomorrow
      let nextDay = add(new Date(), { days: 1 });
      while (isWeekend(nextDay) || nonTradingDaysForMic.includes(format(nextDay, 'yyyy-MM-dd'))) {
        nextDay = add(nextDay, { days: 1 });
      }

      return nextDay;
    },
    [getNonTradingDaysByMic],
  );

  return {
    getNonTradingDaysByMic,
    getNextTradingDay,
  };
};
